import { secureGet } from "../../../Config/ApiConfig";

export const getUser = async (id) => {
    const { data } = await secureGet('/users/me');
    return data;
};
